import { RiskIncidentPanelWebComponent } from './component/RiskIncidentPanelWebComponent';
import { WEB_COMPONENT_RISK_INCIDENT_PANEL } from '../../webcomponents.constants';

export { RiskIncidentPanelWebComponent };

window.customElements.define(WEB_COMPONENT_RISK_INCIDENT_PANEL, RiskIncidentPanelWebComponent);
